// // JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// // Import JS
// import menuOpen from './menuOpen';
import { tagFilterConditions } from './constants';
import infiniteScroll from './infiniteScroll';
import { initLightbox } from './lightbox';
import { initMenuEvent } from './menu';
import { initPostsSwiper } from './postsSwiper';
import { initTheme, toggleTheme } from './theme';
import { checkFilterCondition, trimEmoji, trimHash } from './utils';

initLightbox();

// Trim hash symbol of the title of internal tag

const trimHashes = (() => {
  const hashElements = document.querySelectorAll('[data-trimHash]');
  hashElements.forEach((item) => trimHash(item));
})();

const trimEmojis = (() => {
  const emojiElements = document.querySelectorAll('[data-trimEmoji]');
  const postTagsGroups = document.querySelectorAll('[data-post-tags]');
  emojiElements.forEach((item) => trimEmoji(item));
  if (postTagsGroups.length) {
    postTagsGroups.forEach((postTagsGroup) => {
      if (postTagsGroup.firstElementChild) {
        const postTags = postTagsGroup.querySelectorAll('a');
        postTags.forEach((postTag) => trimEmoji(postTag));
      }
    });
  }
})();

window.addEventListener('load', initTheme);
toggleTheme();

initMenuEvent();
infiniteScroll();

import { initCarousel } from './carousel';
initCarousel();

initPostsSwiper();

// const showMenu = () => {
//   const showMenuButton = document.querySelector('#show-menu');
//   const menu = document.querySelector('#menu');
//   showMenuButton.addEventListener('click', () => {
//     menu.ariaHidden = false;
//     document.body.classList.add('fixed');
//   });
// };

// const hideMenu = () => {
//   const hideMenuButton = document.querySelector('#hide-menu');
//   const menu = document.querySelector('#menu');
//   hideMenuButton.addEventListener('click', () => {
//     menu.ariaHidden = true;
//     document.body.classList.remove('fixed');
//   });
// };

const scrollToTopButton = document.querySelector('#scroll-to-top');
scrollToTopButton.addEventListener('click', () => {
  window.scroll(
    {
      top: 0,
      left: 0,
      behavior: 'smooth',
    },
    passiveSupported ? { passive: true } : false
  );
});

window.addEventListener('scroll', () => {
  scrollToTopButton.ariaHidden = window.scrollY < window.innerHeight;
});

window.addEventListener('resize', () => {
  if (window.innerWidth >= 1024) {
    document.body.dataset.head = 'close';
  }
  scrollToTopButton.ariaHidden = window.scrollY < window.innerHeight;
});

const locationFilters = () => {
  const tagFilterGroup = document.querySelector('[data-location-filters]');
  if (tagFilterGroup) {
    Array.from(tagFilterGroup.children).forEach((element) => {
      const posts = tagFilterGroup.nextElementSibling.children;
      element.addEventListener('click', function () {
        Array.from(tagFilterGroup.children).forEach((item) =>
          item.removeAttribute('data-active')
        );
        element.setAttribute('data-active', '');
        if (element.dataset.filter === 'all') {
          Array.from(posts).forEach((post) => (post.ariaHidden = 'false'));
        } else {
          Array.from(posts).forEach(
            (post) =>
              (post.ariaHidden = !checkFilterCondition(
                post.classList,
                tagFilterConditions[element.dataset.filter]
              ))
          );
        }
      });
    });
  }
};

locationFilters();

const lightbox = (() => {
  const images = document.querySelectorAll(
    '.kg-image-card img, .kg-gallery-card img'
  );
  images.forEach((image) => {
    if (image.parentElement.tagName !== 'A') {
      const wrapper = document.createElement('a');
      wrapper.setAttribute('data-fslightbox', '');
      wrapper.setAttribute('href', image.src);
      image.parentElement.insertBefore(wrapper, image);
      wrapper.appendChild(image);
    }
  });
  refreshFsLightbox();
})();

const styleGhostEmbedCard = (() => {
  const cards = document.querySelectorAll('.kg-card.kg-embed-card');
  cards.forEach((card) => {
    const frame = card.querySelector('iframe');
    if (
      frame.nextElementSibling &&
      frame.nextElementSibling.firstElementChild.firstElementChild
        .textContent === 'short'
    ) {
      frame.classList.add('short');
      frame.nextElementSibling.remove();
    }
  });
})();

(() => {
  if (
    !document.documentElement.hasAttribute('data-team') &&
    document.body.querySelector('[data-team]')
  ) {
    const element = document.body.querySelector('[data-team]');
    while (element.nextElementSibling) {
      element.nextElementSibling.remove();
    }
  }
})();
